import { render, staticRenderFns } from "./supplierComplianceInspectionWZ.vue?vue&type=template&id=6c1c9633&scoped=true"
import script from "./supplierComplianceInspectionWZ.vue?vue&type=script&lang=js"
export * from "./supplierComplianceInspectionWZ.vue?vue&type=script&lang=js"
import style0 from "./supplierComplianceInspectionWZ.vue?vue&type=style&index=0&id=6c1c9633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c9633",
  null
  
)

export default component.exports